<div class="table-responsive">
  <table
    class="genaric-table"
    mat-table
    [dataSource]="dataSource?.items"
    matSort
    (matSortChange)="handleSortChange($event)"
  >
    <!-- Checkbox Column (only when enableRowSelection is true) -->
    @if (enableRowSelection) {
      <ng-container matColumnDef="checkbox">
        <th mat-header-cell *matHeaderCellDef class="text-primary">
          <mat-checkbox
            [checked]="selectAll"
            [indeterminate]="isIndeterminate"
            (change)="toggleSelectAll()"
          ></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-checkbox [checked]="isItemSelected(element)" (change)="toggleItemSelection(element)"></mat-checkbox>
        </td>
      </ng-container>
    }

    @for (column of columns; track column.name) {
      <ng-container [matColumnDef]="column.name">
        @if (column.sort) {
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-primary">{{ column.title }}</th>
        } @else {
          <th mat-header-cell *matHeaderCellDef class="text-primary">{{ column.title }}</th>
        }
        <td mat-cell *matCellDef="let element">
          @let reason = column.reason?.(element);
          @let cellClasses = column.renderCellClasses?.(column, element);

          @if (column.name === 'actions') {
            @switch (column.type) {
              @case (TableActionType.Checkbox) {
                <educare-checkbox
                  [items]="column.items"
                  [selected]="element.selected"
                  [disabled]="element.disabled"
                  [multiple]="false"
                  (selectionChange)="handleAction({ $event, column, action: {}, element })"
                ></educare-checkbox>
              }
              @case (TableActionType.IconButton) {
                @for (action of column.actions; track action.id || $index) {
                  <button
                    matTooltip="{{ action.tooltip }}"
                    matTooltipPosition="below"
                    class="border-0 bg-transparent"
                    [class.d-none]="action.hidden ? action.hidden(element) : false"
                    (click)="handleAction({ $event, column, action, element }); $event.stopPropagation()"
                    [disabled]="action.disabled ? action.disabled(element) : false"
                  >
                    @if (action.matIcon) {
                      <mat-icon>{{ action.matIcon }}</mat-icon>
                    } @else {
                      <i class="das {{ action.iconClass }}  fs-5"></i>
                    }
                  </button>
                }
              }
            }
          } @else if (column.name === 'imagePoster') {
            <i
              (click)="handleUsersClick({ $event, column, element })"
              [attr.tabindex]="false"
              (keyup.enter)="handleUsersClick({ $event, column, element })"
              (keyup.space)="handleUsersClick({ $event, column, element })"
              class="das das-image-icon icon"
            ></i>
          } @else if (column.name === 'participantDetails') {
            <i
              class="{{ cellClasses }} "
              (click)="column.onClick?.(element)"
              [attr.tabindex]="0"
              (keyup.enter)="column.onClick?.(element)"
              (keyup.space)="column.onClick?.(element)"
            ></i>
          } @else if (column.name === 'entities') {
            @if (element.entities?.length > 1) {
              <a
                href="javascript:void(0)"
                class="sub-entity-link"
                matTooltip="View all entities"
                (click)="handleUsersClick({ $event: $event, column, element })"
                (keyup.enter)="handleUsersClick({ $event: $event, column, element })"
                (keyup.space)="handleUsersClick({ $event: $event, column, element })"
                aria-label="View entities"
                tabindex="0"
              >
                {{ element.entities[0]?.name }}
                <span class="view-all">... more</span>
              </a>
            } @else {
              <span>{{ element.entities?.[0]?.name || 'N/A' }}</span>
            }
          } @else if (column.name === 'subEntities') {
            @if (element.subEntities?.length > 1) {
              <a
                href="javascript:void(0)"
                class="sub-entity-link"
                matTooltip="View all sub_entities"
                (click)="handleUsersClick({ $event: $event, column, element })"
                (keyup.enter)="handleUsersClick({ $event: $event, column, element })"
                (keyup.space)="handleUsersClick({ $event: $event, column, element })"
                aria-label="View sub-entities"
                tabindex="0"
              >
                {{ element.subEntities[0]?.name }}
                <span class="view-all">... more</span>
              </a>
            } @else {
              <span>{{ element.subEntities?.[0]?.name || 'N/A' }}</span>
            }
          } @else if (column.name === 'users') {
            @if (element.users?.length > 1) {
              <a
                href="javascript:void(0)"
                class="sub-entity-link"
                matTooltip="View all users"
                (click)="handleUsersClick({ $event: $event, column, element })"
                (keyup.enter)="handleUsersClick({ $event: $event, column, element })"
                (keyup.space)="handleUsersClick({ $event: $event, column, element })"
                tabindex="0"
              >
                {{ element.users[0]?.first_name }} {{ element.users[0]?.last_name }}
                <span class="view-all">... more</span>
              </a>
            } @else {
              <span> {{ element.users[0]?.first_name || '' }} {{ element.users[0]?.last_name || 'N/A' }} </span>
            }
          } @else if (column.name === 'user') {
            @if (element.usersList?.length > 3) {
              <a
                href="javascript:void(0)"
                class="sub-entity-link"
                matTooltip="View all users"
                (click)="handleUsersClick({ $event: $event, column, element })"
                (keyup.enter)="handleUsersClick({ $event: $event, column, element })"
                (keyup.space)="handleUsersClick({ $event: $event, column, element })"
                tabindex="0"
              >
                {{ (element.usersList | slice: 0 : 3)?.join(', ') }}
                <span class="view-all">... more</span>
              </a>
            } @else if (element.usersList?.length > 0) {
              <span> {{ element.usersList?.join(', ') || 'N/A' }} </span>
            } @else {
              <span> N/A </span>
            }
          } @else if (column.name === 'group') {
            @if (element.groupsList?.length > 3) {
              <a
                href="javascript:void(0)"
                class="sub-entity-link"
                matTooltip="View all groups"
                (click)="handleUsersClick({ $event: $event, column, element })"
                (keyup.enter)="handleUsersClick({ $event: $event, column, element })"
                (keyup.space)="handleUsersClick({ $event: $event, column, element })"
                tabindex="0"
              >
                {{ (element.groupsList | slice: 0 : 3)?.join(', ') }}
                <span class="view-all">... more</span>
              </a>
            } @else if (element.groupsList?.length > 0) {
              <span> {{ element.groupsList?.join(', ') || 'N/A' }} </span>
            } @else {
              <span> N/A </span>
            }
          } @else if (column.name === 'entitiesDisplay') {
            @if (element.entitiesListForDialog?.length > 1) {
              <a
                href="javascript:void(0)"
                class="sub-entity-link"
                matTooltip="{{ 'auditTrail.faceRecognitionConfig.viewAllEntities' | translate }}"
                (click)="handleUsersClick({ $event: $event, column, element })"
                (keyup.enter)="handleUsersClick({ $event: $event, column, element })"
                (keyup.space)="handleUsersClick({ $event: $event, column, element })"
                [attr.aria-label]="'auditTrail.faceRecognitionConfig.viewAllEntities' | translate"
                tabindex="0"
              >
                {{ element.entitiesListForDialog[0] }}
                <span class="view-all">{{ 'auditTrail.faceRecognitionConfig.entitiesAndMore' | translate }}</span>
              </a>
            } @else if (element.entitiesListForDialog?.length === 1) {
              <span>{{ element.entitiesListForDialog[0] }}</span>
            } @else {
              <span>N/A</span>
            }
          } @else if (
            column.name === 'name' &&
            (element.type === 'folder' || element.type === 'document' || element.type === 'file')
          ) {
            <div
              class="d-flex align-items-center text-start"
              style="cursor: pointer"
              [attr.tabindex]="0"
              (click)="handleUsersClick({ $event, column, element })"
              (keyup.enter)="handleUsersClick({ $event, column, element })"
              (keyup.space)="handleUsersClick({ $event, column, element })"
            >
              <educare-file-icon
                [iconType]="getFileIconType(element)"
                size="medium"
                [containerClass]="
                  'list-icon-container me-2 ' + (element.type === 'folder' ? 'folder-icon' : 'document-icon')
                "
              ></educare-file-icon>
              <div>
                <div class="item-name">{{ element.name }}</div>
                @if (element.type === 'folder' && element.fileCount) {
                  <div class="fs-12 text-muted mt-1">{{ element.fileCount }} files</div>
                }
                @if ((element.type === 'document' || element.type === 'file') && element.size) {
                  <div class="fs-12 text-muted">{{ element.size }}</div>
                }
              </div>
            </div>
          } @else {
            <div class="cell-container">
              <span class="{{ cellClasses }} status-badge">{{ element[column.name] }}</span>
              @if (reason?.isVisible) {
                <span
                  class="view-reason"
                  [attr.tabindex]="false"
                  (click)="handleUsersClick({ $event, column: reason, element })"
                  (keyup.enter)="handleUsersClick({ $event, column: reason, element })"
                  (keyup.space)="handleUsersClick({ $event, column: reason, element })"
                  >{{ 'moderation.viewReason' | translate }}</span
                >
              }
            </div>
          }
        </td>
      </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      [ngClass]="{ 'disabled-row': row.disabled, 'light-red-row': row.status === 'DELETED' }"
      mat-row
      *matRowDef="let row; columns: displayedColumns"
    ></tr>

    <!-- No Records Found -->
    <tr *matNoDataRow>
      <td [attr.colspan]="displayedColumns.length" class="text-center text-muted py-3">
        {{ 'messages.info.noRecordsFound' | translate }}
      </td>
    </tr>
  </table>
</div>

<!-- Bottom section with selection count and pagination -->
@if (!!dataSource.count) {
  <div class="table-footer d-flex justify-content-between align-items-center">
    <!-- Selection count on the left -->
    <div class="selection-info">
      @if (enableRowSelection) {
        <span class="selection-count"> Selected {{ totalSelectedCount || selectedItems.length }} </span>
      }
    </div>

    <!-- Pagination on the right -->
    <mat-paginator
      [length]="dataSource.count"
      [pageSize]="dataSource.limit"
      [pageIndex]="dataSource.page - 1"
      [hidePageSize]="true"
      (page)="handlePageChange($event)"
      showFirstLastButtons="true"
    ></mat-paginator>
  </div>
}
